// src/pages/Proposta/PropostaPage.jsx
import React from 'react';
import PropostaList from '../../components/Proposta/PropostaList';

const PropostaPage = () => {
    return (
        <div>
            <h1>Gestão de Propostas</h1>
            <PropostaList />
        </div>
    );
};

export default PropostaPage;